<template>
  <v-button @click="onClick" class="c-open-order-entry" variant="link" :class="{ buy: isBuy, sell: isSell }">
    <slot></slot>
    <span class="sr-only" v-if="embedded">{{ $t('white-label.screenReaderLabels.screenReaderOrderEntryLabel') }}</span>
  </v-button>
</template>

<script>
export default {
  name: 'c-open-order-entry',
  props: {
    action: {
      type: String,
      required: true
    },
    limit: {
      required: true
    },
    ric: {
      type: String,
      required: true
    },
    ticketType: {
      type: String
    },
    buyAction: {
      type: Function
    },
    sellAction: {
      type: Function
    },
    quantity: {
      type: [Number, String]
    },
    accountId: {
      type: String
    },
    embedded: {
      type: Boolean
    },
    isFractional: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isBuy() {
      let buySellAtType;
      if (this.ticketType === 'option') {
        buySellAtType = this.$store.state.applicationSettings.orders.settings.options.buySellAtType;
      } else {
        buySellAtType = this.$store.state.applicationSettings.orders.settings.stocks.buySellAtType;
      }
      if (
        (buySellAtType === 'buyAtAsk' && this.action === 'ask') ||
        (buySellAtType === 'buyAtBid' && this.action === 'bid')
      ) {
        return true;
      } else if (
        (buySellAtType === 'buyAtAsk' && this.action === 'bid') ||
        (buySellAtType === 'buyAtBid' && this.action === 'ask')
      ) {
        return false;
      }
    },
    isSell() {
      return !this.isBuy;
    },
    isShortPosition() {
      return this.quantity < 0;
    },
    isClose() {
      return this.accountId && ((this.isSell && !this.isShortPosition) || (this.isBuy && this.isShortPosition));
    },
    defaultQuantity() {
      if (this.ticketType === 'option') {
        return this.$store.state.applicationSettings.orders.settings.options.defaultOrderQuantity;
      } else {
        return this.$store.state.applicationSettings.orders.settings.stocks.defaultOrderQuantity;
      }
    },
    isFractionalTradingAllowed() {
      return this.$store.getters['accounts/isFractionalTradingAllowed'];
    }
  },
  methods: {
    onClick() {
      if (this.buyAction || this.sellAction) {
        if (this.isBuy) {
          this.buyAction(this.limit);
        } else {
          this.sellAction(this.limit);
        }
      } else {
        let modifier = '';
        let limit = '';
        if (this.action === 'bid' || this.action === 'ask') {
          modifier = 'limit';
          limit = Number.parseFloat(this.limit);
        }
        let isFractional = this.isFractional && !this.isBuy;
        this.$widget.openOrderEntry({
          orderMode: { action: this.isBuy ? 'BUY' : 'SELL', modifier: modifier, limit: limit, close: this.isClose },
          legs: {
            firstOrder: {
              symbol: { ric: this.ric },
              ticketType: isFractional ? 'fractional' : this.ticketType,
              quantity:
                this.isBuy && !this.isShortPosition
                  ? this.defaultQuantity
                  : !this.isFractionalTradingAllowed
                  ? Number.parseInt(this.quantity)
                  : this.quantity,
              fractionalQuantityType: isFractional ? '#' : '',
              isFractional
            }
          },
          accountId: this.accountId
        });
      }
    }
  }
};
</script>

<style lang="scss">
@import '~@/styles/components/custom/_c-open-order-entry';
</style>
